import type { WorkingSetCounts } from '@/data/provider/types';

export const WORKING_SET_META_KEYS = {
  lastRefreshAt: 'workingSet:lastRefreshAt',
  counts: 'workingSet:counts',
  isReady: 'workingSet:isReady',
  lastFinalizedBySite: 'workingSet:lastFinalizedBySite',
  watermark: 'workingSet:watermark',
} as const;

export const WORKING_SET_REFRESH_INTERVAL_MINUTES = 15;

export const WORKING_SET_EMPTY_COUNTS: WorkingSetCounts = {
  companies: 0,
  sites: 0,
  units: 0,
  contacts: 0,
  reports: 0,
  templates: 0,
  catalogs: 0,
};

export const workingSetSpec = {
  refreshCadenceMinutes: WORKING_SET_REFRESH_INTERVAL_MINUTES,
  entities: {
    companies: true,
    sites: true,
    units: true,
    contacts: true,
    templates: true,
    catalogs: true,
    reports: 'lastFinalizedPerSite' as const,
  },
  refreshOrder: ['assignments', 'masterData', 'lastFinalizedReports', 'catalogsAndTemplates'],
  firstRunBehavior: 'download-now' as const,
};
